const extractBasket = (response) => {
	const data = response.data;
	const basket = data.basketData || data;

	return {
		basketItems: basket.basketItems || {},
		productsCount: basket.basketSummary?.productsCount || 0,
	};
};

const toKey = (id) => String(id);

export { extractBasket, toKey }; 
